import React, { useState, useEffect } from "react";

function FaucetBalanceChecker(props) {
  const [balance, setBalance] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function initialFetch() {
      setIsLoading(true);
      try {
        const response = await fetch(
          `https://${props.server}.dase.io:8081/api/v37/balances?zetoniumUserId=${process.env.REACT_APP_MASTER_USER_ID}`
        );
        if (!response.ok) {
          throw new Error(`Network error: ${response.status} ${response.statusText}`);
        }
        const payload = await response.json();
        setBalance(payload);
      } catch (error) {
        setBalance({});
      } finally {
        setIsLoading(false);
      }
    }
    initialFetch();
  }, [props.server]);

  const handleClick = async () => {
    setIsLoading(true);
    const response = await fetch(
      `https://${props.server}.dase.io:8081/api/v37/balances?zetoniumUserId=0xb85973a890991e1d3cc2f5925302a532a9d17b71`
    ).then((res) => res.json());
    setBalance(response);
    setIsLoading(false);
  };

  return (
    <>
      <div class="button is-primary is-size-6" onClick={handleClick}>
        Check Bank Balance
      </div>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <>
          <p data-cy="p-silver-zet">Silver Żetons: {parseFloat(balance.silver_leos) / 1000000}</p>
          <p data-cy="p-gold-zet">Gold Żetons: {parseFloat(balance.gold_leos) / 10000000}</p>
        </>
      )}
    </>
  );
}

export default FaucetBalanceChecker;
